<template>
  <div class="login">
    <div class="login-box">
      <div style="text-align: center; margin-bottom: 15px;">
        <img src="../assets/images/logo.png" alt="">
      </div>
      <div class="upload-content">
        <div class="upload-content-item">
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(1)">申报工作通知</el-link> |
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(2)">项目申报书</el-link> |
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(3)">个人申报书</el-link>
        </div>
        <div class="upload-content-item">
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(6)">系统填报手册</el-link> |
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(5)">科技奖励办法</el-link> |
          <el-link style="font-size: 18px; color: #fff;" type="primary" :underline="false" @click="download(4)">办法实施细则</el-link>
        </div>
      </div>
      <div class="login-container">
        <div class="tab">
          <div :class="active == index? 'active': ''" v-for="(item, index) in tab" :key="index" @click="switchover(index)">{{item}}</div>
        </div>
        <el-form :model="userInfo" :rules="rules" ref="userInfo" class="demo-ruleForm" style="margin-top: 20px;">
          <div v-if="active == 0" >
            <el-form-item prop="account">
              <el-input v-model.trim="userInfo.account" placeholder="请输入手机号" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <!-- <el-input v-model.trim="userInfo.pwd" type="password" placeholder="请输入登录密码"></el-input> -->
              <el-input :type="pwd ?'password': 'text'" v-model.trim="userInfo.pwd" placeholder="请输入登录密码">
                <i
                slot="suffix"
                style="margin-right: 6px;"
                class="cursor" :class="pwd? 'iconfont icon-xianshi': 'iconfont icon-yincang'"
                @click="pwd = !pwd"></i>
              </el-input>
            </el-form-item>
          </div>
          <div v-if="active == 1" >
            <el-form-item prop="phone">
              <el-input v-model.trim="userInfo.phone" maxlength="11" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code" style="position: relative;">
              <el-input  v-model.trim="userInfo.code" placeholder="请输入短信验证码" maxlength="6"></el-input>
              <div class="box" v-if="disabled"><span style="cursor: pointer;" @click.stop="getCode">{{btnTxt}}</span></div>
              <div class="box" v-if="!disabled"><span style="color: #999;">{{txt}}</span></div>
            </el-form-item>
          </div>
          <div >
            <el-alert
              :closable="false"
              title=""
              type="warning"
              show-icon>
              <span slot="title">
                <div v-html="alertConten"></div>
              </span>
            </el-alert>
          </div>
          <div style="margin: 20px 0;">
            <!-- <div style="font-size: 12px; margin-bottom: 14px; color: #409EFF; text-align: center;">
            </div> -->
            <el-button style="width: 100%;" type="primary" :loading="loading" @click="handleSubmit">登录</el-button>
          </div>
          <!-- border-bottom: 1px #777 dashed;  -->
          <div style="display: flex; justify-content: flex-end; padding-bottom: 15px;">
            <div style="flex: 1; font-size: 12px;">
              <!-- 当前阶段未在申报时间范围内，无法注册 -->
              <el-link v-if="registerState == 1" type="primary" :underline="false" style="font-size: 12px; vertical-align: baseline;" @click="next('sign')">立即注册</el-link>
            </div>
            <el-link type="primary" :underline="false" style="font-size: 12px; vertical-align: baseline;" @click="next('retrieve')">忘记登录密码?</el-link>
          </div>
          <!-- <div style="display: flex; justify-content: space-between">
            <div class="hj-btn" @click="handleAward('awardInformation')">
              往届获奖信息查询
            </div>
            <div class="hj-btn" @click="handleAward('awardCertificate')" style="margin-left: 20px">
              往届电子证书打印
            </div>
          </div> -->
        </el-form>
      </div>
    </div>
    <Verificate :isShow="isShow" @success="successVer()" @cancel="cancleVer()"></Verificate>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Qs from 'qs'
import Verificate from '@/components/verificate/Verificate'
import { LoginGetPhoneMa, LoginAdminLogin, LoginNoteLogin, uploadFileDownload } from '@/api/system'
import { getMangerStatus, getLoginStatus } from '@/api/admin'
import { increasedGetWebFiles, increasedGetofficial } from '@/api/increased'
const Base64 = require('js-base64').Base64
export default {
  components: { Verificate },
  data() {
    return {
      pwd: true,
      fileList: {},
      alertConten: '',
      registerState: '',
      status: '',
      tab: ['账号登录', '短信登录'],
      active: 0,
      loading: false,
      isShow: false,
      userInfo: {
        account: '',
        pwd: '',
        phone: '',
        code: '',
        checked: true
      },
      rules: {
        account: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur'] }
        ],
        pwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur'] }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      disabled: true,
      btnTxt: '获取验证码',
      txt: ''
    }
  },
  created() {
    // 获取文件
    increasedGetWebFiles({}).then(res => {
      if (res.code == '000') {
        this.fileList = res.result
      }
    })
    // 文案
    increasedGetofficial({}).then(res => {
      if (res.code == '000') {
        this.alertConten = res.result[1].remarks
      }
    })
    this.getStatus()
    if (window.sessionStorage.getItem('state') == 2) {
      // console.log(window.sessionStorage.getItem('state'))
      window.sessionStorage.removeItem('state')
      this.getStatus().then(() => {
        if (this.status != 1) return this.$message.warning('系统关闭中')
      })
    }
    this.keyupSubmit()
  },
  watch: {
    'active'(n, o) {
      if (n === 0) {
        this.btnTxt = '获取验证码'
        this.disabled = true
        this.txt = ''
      }
    }
  },
  methods: {
    // 回车
    keyupSubmit () {
      document.onkeydown = e => {
        const key = window.event.keyCode
        if (key === 13) {
          this.handleSubmit()
        }
      }
    },
    handleSubmit() {
      this.$refs.userInfo.validate((valid) => {
        if (!valid) return false
        this.getStatus().then(() => {
          if (this.status != 1) return this.$message.warning('系统关闭中')
          if (this.active === 0) {
            this.isShow = true
          } else if (this.active === 1) {
            this.loading = true
            // getLoginStatus({ id})
            getLoginStatus({ id: this.userInfo.phone }).then(res => {
              if (res.code == '000') {
                LoginNoteLogin({ mobile: this.userInfo.phone, valCode: this.userInfo.code }).then(res => {
                  this.loading = false
                  if (res.code === '000') {
                    this.$message.success('登录成功')
                    window.sessionStorage.setItem('token', res.result.tokenType + ' ' + res.result.accessToken)
                    window.sessionStorage.setItem('login', res.result.tokenType + ' ' + res.result.accessToken)
                    this.$router.replace({ path: '/' })
                  }
                  if (res.code == '904') {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.loading = false
              }
            })
          }
        })
      })
    },
    // 获取短信验证码 1、 唤起滑块校验
    getCode () {
      this.$refs.userInfo.validateField('phone', valid => {
        if (valid) return false
        this.getStatus().then(() => {
          if (this.status != 1) return this.$message.warning('系统关闭中')
          this.isShow = true
        })
      })
    },
    // 回调 登录
    // 1 active == 0 账号密码登录      2、active == 1 发送短信验证码
    successVer () {
      this.isShow = false
      if (this.active === 0) {
        this.userPwsLogin()
      } else if (this.active === 1) {
        LoginGetPhoneMa({ mobile: this.userInfo.phone }).then((res) => {
          if (res.code === '000') {
            this.$message.success('验证码发送成功')
            this.time = 60
            this.disabled = false
            this.timer()
          }
        })
      }
    },
    cancleVer () {
      this.isShow = false
    },
    // 计时器
    timer () {
      if (this.time > 0) {
        this.time--
        this.txt = this.time + 's'
        setTimeout(this.timer, 1000)
      } else {
        this.btnTxt = '重新获取'
        this.disabled = true
        this.time = 0
      }
    },
    // 登录
    userPwsLogin() {
      this.loading = true
      getLoginStatus({ id: this.userInfo.account }).then(res => {
        if (res.code == '000') {
          const token = 'Basic ' + Base64.encode(this.userInfo.account + ':' + md5(this.userInfo.pwd))
          window.sessionStorage.setItem('token', token)
          LoginAdminLogin(Qs.stringify({ ltype: 'web' })).then(res => {
            this.loading = false
            if (res.code === '000') {
              this.$message.success('登录成功')
              window.sessionStorage.setItem('token', res.result.tokenType + ' ' + res.result.accessToken)
              // window.sessionStorage.setItem('loginName', res.result.user.loginName)
              window.sessionStorage.setItem('login', res.result.tokenType + ' ' + res.result.accessToken)
              window.sessionStorage.setItem('userId', res.result.user.id)
              this.$router.replace({ path: '/' })
            } else {
              // console.log('失败')
              window.sessionStorage.clear()
            }
          })
        } else {
          this.loading = false
        }
      })
    },
    switchover(index) {
      if (index == this.active) return false
      this.active = index
      this.$refs.userInfo.resetFields()
    },
    download(status) {
      // const name = this.fileList['file' + status].remark
      // uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
      //   const blob = new Blob([res.data])
      //   // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
      //   const fileName = name
      //   if ('download' in document.createElement('a')) { // 非IE下载
      //     const elink = document.createElement('a')
      //     elink.download = fileName
      //     elink.style.display = 'none'
      //     elink.href = URL.createObjectURL(blob)
      //     document.body.appendChild(elink)
      //     elink.click()
      //     URL.revokeObjectURL(elink.href) // 释放URL 对象
      //     document.body.removeChild(elink)
      //   } else { // IE10+下载
      //     navigator.msSaveBlob(blob, fileName)
      //   }
      // })
      this.downloadFile(status)
      // if (status == 1) {
      //   this.downloadFile(8)
      // }
    },
    downloadFile(status) {
      const name = this.fileList['file' + status].remark
      uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
        const blob = new Blob([res.data])
        // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    next(path) {
      this.getStatus().then(() => {
        if (this.status == 1) {
          this.$router.push({ path })
        } else {
          this.$message.warning('系统关闭中')
        }
      })
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.status = res.result.state
          this.registerState = res.result.registerState
        }
      })
    },
    handleAward(path) {
      window.open(path, '_blank')
      // this.$router.push({ path })
    }
  }
}
</script>

<style lang="less">
.el-form-item-box {
  .el-form-item__content {
    line-height: normal;
  }
}
</style>

<style lang="less" scoped>
.hj-btn {
  margin-top: 15px;
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #409EFF;
  border-radius: 4px;
  color: #409EFF;
  cursor: pointer;
}
.el-alert--warning.is-light {
  border: 1px solid #F1924E;
  box-sizing: border-box;
}
.upload-content {
  width: 100%;
  background: #409EFF;
  box-shadow: 0px 2px 12px 0px rgba(39, 70, 247, 0.2);
  border-radius: 10px;
  margin-bottom: 15px;
  color: #fff;
  text-align: center;
  padding: 12px 0px;
  .upload-content-item + .upload-content-item {
    margin-top: 10px;
  }
  .upload-content-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .el-link {
      flex: 1;
    }
  }
}
.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url(../assets/images/login.jpg) no-repeat;
  background-size: cover;
  .login-container {
    width: 500px;
    // height: 300px;
    padding: 10px 50px 20px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 6px;
  }
}
.tab {
  width: 100%;
  display: flex;
  div {
    flex: 1;
    text-align: center;
    height: 60px;
    line-height: 60px;
    border-bottom: 4px solid rgb(233 233 233);
    box-sizing: border-box;
    cursor: pointer;
    font-size: 18px;
  }
  div.active {
    border-bottom: 4px solid rgb(64 158 255);
  }
}
.box::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 16px;
  top: 12px;
  left: 0;
  background: #D8D8D8;
}
.box {
  width: 120px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  font-size: 14px;
  color: #2A73FF;
}

</style>
